import React from "react"; 
import { HiOutlineViewList } from 'react-icons/hi'; 
import './style.css';
 let CruxCompetetive=(props)=> {
    return(
  <div>
    <nav class="navbar navbar-expand-lg py-3">
      <div class="container">
        <a href="#" class="navbar-brand">
          <img src="https://bootstrapious.com/i/snippets/sn-nav-logo/logo.png" width="45" alt="" class="d-inline-block align-middle mr-2" /> <span className="text-uppercase font-weight-bold">Company</span>
        </a>
        <button id='navResponsiveButton' type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" className="navbar-toggler"><span className="navbar-toggler-icon"></span> 
          <HiOutlineViewList size={30} id='threebutt' />
        </button>
        <div id="navbarSupportedContent" className="collapse navbar-collapse">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item active"><a href="#" className="nav-link"  onClick={()=>props.history.push('/')} >Home <span className="sr-only">(current)</span></a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Services</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >About </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Contact </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" id='cas-link'>Case Studies</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link"  onClick={()=>props.history.push('/signin')}      >Signin</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div id="centerME">
      <div className="boxStAc2">
        <h4 id="h4">
  Crux Competetive
  </h4>
        <br></br>
        <h6 id="h62">Solution scorecard evaluates effectiveness of your solution to solve the problem</h6>
        <h6 id="h6">
  Solution scorecard also enables you to understand many critical aspect of the solution as your are evaluating it</h6>
        <div id='divL'>
          <table>
            <thead>
              <tr>{/*
                <th scope="col" id="font13">Sr No.</th>*/}
                <th scope="col" colSpan={2} id="f12">Category</th>
                <th scope="col" id="f12">Competator 1</th>
                <th scope="col" id="f12">Competator 2</th>
                <th scope="col" id="f12">Competator 3</th>
                <th scope="col" id="f12">Competator 4</th>
                <th scope="col" id="f12">Your Solution</th>
                <th scope="col" id="f12">Game Changer</th>
                <th scope="col" colSpan={4} id="f12">Game Changer
                  <br />Impact</th>
                <th scope="col" id="f12">Winner</th>
                <th scope="col" id="f12">Loser</th>
                <th scope="col" id="f12">Tie</th>
              </tr>
            </thead>
            <tbody>
              <tr>{/*
                <td data-label="Sr No.">1</td>*/}
                <td data-label="Category" colSpan={2} id="font13">Differentiator 1 Name</td>
                <td data-label="Competator 1" id="font13">
                  <select id="selecthlm">
                    <option value="0">L/M/H/No</option>
                    <option value="1">L</option>
                    <option value="2">M</option>
                    <option value="3">H</option>
                    <option value="3">No</option>
                  </select>
                </td>
                <td data-label="Competator 2" id="font13">
                  <select id="selecthlm">
                    <option value="0">L/M/H/No</option>
                    <option value="1">L</option>
                    <option value="2">M</option>
                    <option value="3">H</option>
                    <option value="3">No</option>
                  </select>
                </td>
                <td data-label="Competator 3" id="font13">
                  <select id="selecthlm">
                    <option value="0">L/M/H/No</option>
                    <option value="1">L</option>
                    <option value="2">M</option>
                    <option value="3">H</option>
                    <option value="3">No</option>
                  </select>
                </td>
                <td data-label="Competator 4" id="font13">
                  <select id="selecthlm">
                    <option value="0">L/M/H/No</option>
                    <option value="1">L</option>
                    <option value="2">M</option>
                    <option value="3">H</option>
                    <option value="3">No</option>
                  </select>
                </td>
                <td data-label="Your Solution" id="font13">
                  <select id="selecthlm">
                    <option value="0">L/M/H/No</option>
                    <option value="1">L</option>
                    <option value="2">M</option>
                    <option value="3">H</option>
                    <option value="3">No</option>
                  </select>
                </td>
                <td data-label="Game Changer" id="font13">
                  <select id="selectYesNo">
                    <option value="0">yes/no</option>
                    <option value="1">Yes</option>
                      <option value="3">No</option>
                  </select>
                </td>
                <td colSpan={4} data-label='Game Changer Impact'>
                  <input type="text" style={{width:120,marginTop:16}} className="input1"></input>
                </td>
                <td data-label="winner" id="font13">
                  <select id="selectYesNo">
                    <option value="0">yes/no</option>
                    <option value="1">Yes</option>
                      <option value="3">No</option>
                  </select>
                </td>
                <td data-label="loser" id="font13">
                  <select id="selectYesNo">
                    <option value="0">yes/no</option>
                    <option value="1">Yes</option>
                      <option value="3">No</option>
                  </select>
                </td>
                <td data-label="tie" id="font13">
                  <select id="selectYesNo">
                    <option value="0">yes/no</option>
                    <option value="1">Yes</option>
                      <option value="3">No</option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div id="flexLef">
          <button className="button2" onClick={()=>props.history.push('/solutionScorecard')} id='BackNext'>Back</button>
          <button className="button2" onClick={()=>props.history.push('/cruxAlligment')} id='BackNext'>Next</button>
        </div>
      </div>
    </div>
  </div>) } 
  export default CruxCompetetive;